import cn from 'bem-cn';

import mobileImage from '../../images/telegram-banner/mobile.png';
import desktopLeftImage from '../../images/telegram-banner/desktop-left.png';
import desktopRightImage from '../../images/telegram-banner/desktop-right.png';
import { TELEGRAM_CHANNEL_URL } from '../../constants';
import { MetrikaGoal, ScreenSize, useGetScreenSize, useMetrika } from '../../hooks';
import { Button, Icon, ImageWithFadeIn, Link, Stack } from '../UI';

import { useTelegramBannerVisibility } from './TelegramBanner.hooks';
import './TelegramBanner.scss';

const b = cn('telegram-banner');

export const TelegramBanner = () => {
    const { isVisible, handleClose } = useTelegramBannerVisibility();
    const { reachGoal } = useMetrika();
    const screenSize = useGetScreenSize();

    const isMobile = screenSize < ScreenSize.Tablet;
    const leftImage = isMobile ? mobileImage : desktopLeftImage;

    const handleLinkClick = () => {
        // Сначала выполнится переход по ссылке
        reachGoal(MetrikaGoal.ClickTelegram);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <Link external to={TELEGRAM_CHANNEL_URL} onClick={handleLinkClick}>
            <Stack direction="row" alignItems="center" className={b()}>
                <ImageWithFadeIn className={b('left-image')} src={leftImage} alt="" />
                <Stack
                    direction="row"
                    spacing={24}
                    alignItems="center"
                    justifyContent="space-between"
                    className={b('text-container')}
                >
                    <p className={b('text')}>Мы завели Telegram-канал, чтобы делиться новостями</p>
                    <Button className={b('open-button')}>Открыть</Button>
                </Stack>
                <Stack alignItems="center" justifyContent="center" className={b('close-button')}>
                    <Icon name="close" size={16} onClick={handleClose} />
                </Stack>
                {!isMobile && <ImageWithFadeIn className={b('right-image')} src={desktopRightImage} alt="" />}
            </Stack>
        </Link>
    );
};
